import { Buffer } from 'buffer'
window.Buffer = Buffer
import { createApp, h } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { useAuthStore } from '@/store/modules/auth';
import vSelect from 'vue-select';
import OpenIndicator from '@/components/forms/vselect-open-indicator.vue';
import Swal from 'sweetalert2';
import clickOutside from './directives/clickOutside';
import '@/validation-rules';
import { msalInstance } from '@/auth/msalInstance';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faBackward, faCheck, faChevronDown, faChevronUp, faDownload, faExternalLinkAlt, faFile, faForward,
  faKey, faMinus, faPen, faPlus, faArrowDown, faArrowUp, faArrowDownWideShort, faTimes, faTrashAlt,
  faUndo, faUpload, faBars, faTrash, faCopy
} from '@fortawesome/free-solid-svg-icons';
import { createHead } from '@unhead/vue/client';

// FontAwesome configuration
library.add(
  faBackward, faCheck, faChevronDown, faChevronUp, faDownload, faExternalLinkAlt, faFile, faForward,
  faKey, faMinus, faPen, faPlus, faArrowDown, faArrowUp, faArrowDownWideShort, faTimes, faTrashAlt,
  faUndo, faUpload, faBars, faTrash, faCopy
);
dom.watch();

// vue-select vue3 configuration
vSelect.props.components.default = () => ({
  OpenIndicator,
  Deselect: {
    render() {
      return h('span', { class: 'delete is-medium' });
    }
  },
});

// Create the app
const app = createApp(App);

// Registers plugins and global components
app.component('v-select', vSelect);

// Registers manual directive v-click-outside
app.directive('click-outside', clickOutside);

// Add sweetalert2 globally
app.config.globalProperties.$swal = Swal;

// Mount useHead
const head = createHead();
app.use(head);

// Mount router and store
app.use(router);
app.use(store);

const authStore = useAuthStore();

// Add global authentication
app.config.globalProperties.$auth = {
  getAccessToken: () => authStore.accessToken
};

// MSAL Init and app boot
msalInstance.initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(async (response) => {
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const account = msalInstance.getAllAccounts()[0];
      if (account) {
        msalInstance.setActiveAccount(account);
      }
    }

    let shouldLogout = false;

    try {
      await authStore.updateAuth();
    } catch (e) {
      console.warn('updateAuth failed', e);
      if (e.errorCode === 'monitor_window_timeout') {
        shouldLogout = true;
      }
    }

    // Finally, mounting the app
    app.mount('#app');

    if (shouldLogout) {
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin
      });
    }
  })
  .catch((error) => {
    console.error('Fatal MSAL bootstrap error:', error);
  });

